//import $ from 'jquery';

var selected_mobile_values = "";

var day;
var month;
var year;
var location;
var language;
var domain = window.location.hostname;
var header_text;

function isIE() {
    const ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
    const msie = ua.indexOf('MSIE '); // IE 10 or older
    const trident = ua.indexOf('Trident/'); //IE 11

    return (msie > 0 || trident > 0);
}

function setCookieOverride(location,domain = '.glenfiddich.com') {
    let cookieDate = new Date();
    let cookieDomain = domain;

    cookieDate.setFullYear(cookieDate.getFullYear() + 1);
    cookieDate = cookieDate.toUTCString();

    document.cookie = "age_gate=legal; domain=" + cookieDomain + "; path=/; expires=" + cookieDate + "; secure";
    document.cookie = "age_gate_country=" + location + "; domain=" + cookieDomain + "; path=/; expires=" + cookieDate + "; secure";
    document.cookie = "verified_locale=" + location + "; domain=" + cookieDomain + "; path=/; expires=" + cookieDate + "; secure";
    document.cookie = "country_selection=" + location + "; domain=" + cookieDomain + "; path=/; expires=" + cookieDate + "; secure";

}

function triggerSignup()
{
	setTimeout(function() {
        $(".floater-container").fadeIn('fast');
        
        if (getCookieValue("signupTrigger") == null) {
        	$(".floater").trigger('click');
    		setSignupTriggered();	
        }
        
    }, 5000); // 5000 milliseconds = 5 seconds
}

function getCookieValue(name) {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split("=");
        console.log("Cookie ", cookieName, cookieValue);
        if (cookieName === name) {
        	console.log("Found cookie ", cookieName);
            return cookieValue;
        }
    }
    return null; // Cookie does not exist
}

function setSignupTriggered() {
    let cookieDate = new Date();
    let cookieDomain = window.location.hostname;
    let name = "signupTrigger";
    let value = "1";
    let days = 30;

    cookieDate.setTime(cookieDate.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + cookieDate.toUTCString();
    document.cookie = "signupTrigger=" + value + "; " + expires + "; domain=" + cookieDomain + "; path=/; secure";

}

let searchParams = new URLSearchParams(window.location.search);
$(document).ready(function () {

    //spit out IE 11 or older message - ACH - I know, it's not pretty.
    if (isIE()) {

        $("body").html("<div style='width:100vw;height:100vh; background-color:#FFF; text-align:center;'><div style='padding:30vh 10vw 0 10vw; font-size:2.5vw;'>It appears that you are using a very old and insecure internet browser.<br>Please upgrade your browser in order to view this site.<br><br><a style='text-decoration:underline; font-size:1.5vw' href='https://browser-update.org/update-browser.html'>Click here to learn more.</a></div></div>");

    }

    //forward to other locations  
    header_text = $(".whisky-header-text").html();
    
    if ($("#country_code").val() == "en-in" || domain == "houseofglenfiddich.com" || domain == "www.houseofglenfiddich.com") {
        setCookieOverride("IN", '.houseofglenfiddich.com');
    } else if (searchParams.has('lb') && searchParams.get('lb') == "t") {
        var country_code = $('#country_code').val();
        if (country_code != "") {
            var country_arr = country_code.split("-");
            setCookieOverride(country_arr[1].toUpperCase());
        } else {
            setCookieOverride("XX");
        }
    } else {
        gate_modal();
    }

    accordion();
    age_gate_custom_select();
    animate_age_gate_stag();

    //autotab
    $("#full-day").on('keyup', function () {
        if ($(this).val().length == 2) {
            $("#full-month").focus();
        }
    });

    //tabbed out because of using year only first logic
    /*$("#full-month").on('keyup', function(){
        if($(this).val().length == 2){
            $("#full-year").focus();
        }
    });*/

    //on year blur, submit
    $("#full-year").on('blur', function () {
        age_gate_validate();
    });

    //on entry of 4 characters into the agegate, go straight through
    $("#year").on('keyup', function () {
        if ($(this).val().length == 4) {
            $("#LDAForm_LDAForm_action_LDAFormProcess").focus();
            age_gate_validate();

        }

    });


    //auto blank fields
    $("#full-day").on('focus', function () {
        $(this).val("");
    });

    $("#full-month").on('focus', function () {
        $(this).val("");
    });

    $("#full-year").on('focus', function () {
        $(this).val("");
    });

    $("#year").on('click', function () {
        $(this).val("");
    });

    //age gate field validations
    $("#full-day").on('blur', function () {
        //numerical padded input   
        var inputVal = $(this).val();
        var dayError = false;

        //it's a number
        if (!$.isNumeric(inputVal)) {
            dayError = true;
        }

        //it's a valid day number
        if (inputVal < 1 || inputVal > 31) {
            dayError = true;
        }

        if (dayError) {
            $(this).val("");
        }

    });

    $("#full-month").on('blur', function () {
        //numerical padded input   
        var inputVal = $(this).val();
        var monthError = false;

        //it's a number
        if (!$.isNumeric(inputVal)) {
            monthError = true;
        }

        //it's a valid day number
        if (inputVal < 1 || inputVal > 12) {
            monthError = true;
        }

        if (monthError) {
            $(this).val("");
        }
    });

    $("#full-year").on('blur', function () {
        //numerical padded input   
        var inputVal = $(this).val();
        var yearError = false;

        //it's a number
        if (!$.isNumeric(inputVal)) {
            yearError = true;
        }

        if (yearError) {
            $(this).val("");
        }
    });

    $("#year").on('blur', function () {
        //numerical padded input   
        var inputVal = $(this).val();
        var yearError = false;

        //it's a number
        if (!$.isNumeric(inputVal)) {
            yearError = true;
        }

        if (yearError) {
            $(this).val("");
        }
    });

    //var language = navigator.language;

    //force UK language overwrite above line
    // var language = "en-GB";
    var language = $("#country_code").val();

    var dvlocation = $('.select-stag-wrapper.location .select-items div').map(function () {
        var dval = $(this).attr('data-value');
        var dcontent = $(this).html();
        //console.log(language);

        if (language == "ko" && dval == "KR") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "en-gb" && dval == "GB") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "en-in" && dval == "IN") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "es-ar" && dval == "AR") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "es-pe" && dval == "PE") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "es-co" && dval == "CO") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "es-cl" && dval == "CL") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if ((language == "en-us" || language == "en") && dval == "US") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "ja" && dval == "JP") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "es-mx" && dval == "MX") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "en-au" && dval == "AU") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "fr-fr" && dval == "FR") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "en-in" && dval == "IN") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "de-at" && dval == "AT") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "zh-cn" && dval == "CN") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "zh-tw" && dval == "TW") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "de-de" && dval == "DE") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }
        
        if(language == "zh-cn" && dval == "CN") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }
        
        if(language == "zh-tw" && dval == "TW") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }
        
        if(language == "en-sg" && dval == "SG") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }
        
        if(language == "en-id" && dval == "ID") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }
        
        if(language == "en-ph" && dval == "PH") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }
        
        if(language == "en-my" && dval == "MY") {
            $(this).addClass("selected");
            $(this).parent().parent().find(".select-selected").html(dcontent);
            return $(this).attr('data-value');
        }

        if (language == "" && dval == "XX") {
            return $(this).attr('data-value');
        }

    }).get();


    setTimeout(function () {
        $("#full-day").focus();
        $("#year").focus();
    }, 1500);

    $('.btn-filter').on('click', function () {
        const height = document.querySelector('.filter-modal-wrapper').offsetHeight;
        $("#content").height(height);
        $("#content").css('overflow', 'auto');
        $("#main").css('min-height', '100vh');
        $('.filter-modal').removeClass('hidden');

        $('.footer').addClass("hidden");

    });

    $('.btn-filter-close').on('click', function () {
        $('.filter-modal').addClass('hidden');
        $(".content").css("height", "");

        $('.footer').removeClass("hidden");

    });

    $('.btn-apply-filters').on('click', function () {

        get_mobile_collections();


        $('.filter-modal').addClass('hidden');
        $(".content").css("height", "");

        $("html, body").animate({ scrollTop: 0 });
        $('.footer').removeClass("hidden");

    });

    $('.btn-reset').on('click', function () {
        var checkedVals = $('.filter-modal-wrapper input[type=checkbox]').map(function () {
            return $(this).removeClass('checked');
        }).get();

        $('.filter--count').html("");
        $('.btn-filter').removeClass('with-values');
        $('.filter--footer-counter').html('&nbsp;');

        $(".content").css("height", "");

    });


    $(document).on('click', '.side-label', function (e) {
        var data_name = $(this).parent().find('input[type=checkbox]');
        var attr_name = $(this).parent().find('input[type=checkbox]').attr('name');
        var data_id = $(this).parent().find('input[type=checkbox]').attr('id');
        var checbox_value = $(this).parent().find('input[type=checkbox]').val();
        let data_from = $(this).attr('data-from');

        $(this).parent().find('input[type=checkbox]').toggleClass('checked');
        show_selected_values(data_from);
    });

    $(document).on('click', '.mobile-side-label', function (e) {
        var data_name = $(this).parent().find('input[type=checkbox]');
        var attr_name = $(this).parent().find('input[type=checkbox]').attr('name');
        var data_id = $(this).parent().find('input[type=checkbox]').attr('id');
        var checbox_value = $(this).parent().find('input[type=checkbox]').val();
        let data_from = $(this).attr('data-from');

        $(this).parent().find('input[type=checkbox]').toggleClass('checked');

        show_selected_mobile_values();

    });

    $('#btn-collections').on('click', function () {
        /*$('.section-groups').removeClass('hidden');
        $(".list-counter").removeClass('hidden');
        hide_collections();
        close_accordion($(this));*/

        // get_all_collections('age', 2);
        var id = $(this).attr("id").split("-")[1];
        get_desktop_collections(id);
        close_accordion($(this));
        // $(".whisky-header-text").html("OUR AWARD-WINNING SINGLE MALT WHISKIES");
    });
    $('#btn-age').on('click', function () {
        // get_all_collections('age', 2);
        var id = $(this).attr("id").split("-")[1];
        get_desktop_collections(id);
        close_accordion($(this));
        // $(".whisky-header-text").html("OUR AWARD-WINNING SINGLE MALT WHISKIES");
    });
    $('#btn-tastes').on('click', function () {
        // get_all_collections('tastes', 3);
        var id = $(this).attr("id").split("-")[1];
        get_desktop_collections(id);
        close_accordion($(this));
        // $(".whisky-header-text").html("OUR AWARD-WINNING SINGLE MALT WHISKIES");
    });
    $('#btn-occasions').on('click', function () {
        // get_all_collections('occasions', 1);
        var id = $(this).attr("id").split("-")[1];
        get_desktop_collections(id);
        close_accordion($(this));
        // $(".whisky-header-text").html("A GLENFIDDICH FOR EVERY OCCASION");
    });

    // get string after collection
    var currenturl = window.location.href;
    var requiredurl = currenturl.split('/collection/')[1];

    if (requiredurl) {
        get_collection(requiredurl.replace(/\//g, ""));
    }

    var country_code = $("#country_code").val();
    if (country_code != "") {
        $(".filter-label").each(function (index) {
            if (filter_mapping.hasOwnProperty(country_code) && filter_mapping[country_code].hasOwnProperty($(this).html().toLowerCase())) {
                $(this).html(filter_mapping[country_code][$(this).html().toLowerCase()]);
            }
        });
        $(".accordion--label").each(function (index) {
            if (filter_mapping.hasOwnProperty(country_code) && filter_mapping[country_code].hasOwnProperty($(this).html().toLowerCase())) {
                $(this).html(filter_mapping[country_code][$(this).html().toLowerCase()]);
            }
        });
    }
});

var filter_mapping = {
    "zh-tw": {
        // Translations for the filter label
        "collections": "系列總覽",
        "age": "年份",
        "occasions": "情境",

        // Mapping translation for the URL to be mapped to the filter in different character
        // if URL is flagship-collection this will be mapped in the filter with the corresponding character
        // this will insure that all the filter is selecting and displaying the correct group
        "flagship-collection": "核心酒款",
        "time-reimagined": "時光臻藏系列",
        "travel-exclusive": "非凡永恆臻選系列",
        "grand-series": "奢華系列",
        "experimental-series": "實驗室系列",
        "historic-releases": "限量珍藏系列",
        "rare-and-vintage": "珍稀酒款和高年份酒款",
        "special-editions": "特殊酒款"
    },
    "zh-cn": {
        "collections": "系列",
        "age": "年份",
        "occasions": "饮用场景",
        "flagship-collection": "核心系列",
        "time-reimagined": "时光臻藏系列",
        "grand-series": "璀璨珍藏系列",
        "special-editions": "特别酒款",
        "travel-exclusive": "Travel Exclusive",
        "experimental-series": "Experimental Series",
        "historic-releases": "Historic Releases",
        "rare-and-vintage": "Rare & Vintage"
    },
    "de-de": {
        "collections": "Collections",
        "age": "ALTER",
        "occasions": "ANLÄSSE",
    }
}

function setCollectionsTranslate() {
    var collections_label = $("#collections").find(".filter-container");


    collections_label.each(function (index) {
        var collection_name = $(this).find('.checkbox').attr('data-name');
        collection_name = collection_name.toLowerCase();
        collection_name = collection_name.replaceAll("&", "and");
        collection_name = collection_name.replaceAll(" ", "-");

        if ($("#country_code").val() != "") {
            $(this).find('.side-label').html(filter_mapping[$("#country_code").val()][collection_name]);
            $(this).find('.checkbox').attr('data-name', filter_mapping[$("#country_code").val()][collection_name]);
        }
    });
}

function setAgeTranslate() {
    var age_label = $("#age").find(".filter-container");


    age_label.each(function (index) {
        var age_name = $(this).find('.checkbox').attr('data-name');
        age_name = age_name.toLowerCase();
        age_name = age_name.replaceAll("&", "and");
        age_name = age_name.replaceAll(" ", "-");
        age_name = age_name.replaceAll("+", "-");

        if ($("#country_code").val() != "") {
            $(this).find('.side-label').html(age_text[$("#country_code").val()][age_name]);
            $(this).find('.checkbox').attr('data-name', age_text[$("#country_code").val()][age_name]);
        }
    });
}

function close_accordion(el) {
    // el.parent().parent().parent().find(".accordion").removeClass("is-open");
    // el.parent().parent().removeAttr("style");
    $(".accordion").removeClass("is-open");
    $(".accordion").next().removeAttr("style");
}

function get_collection(requiredurl = false) {
    var sanitized_url = requiredurl.split("?");
    requiredurl = sanitized_url[0];

    if (requiredurl) {
        var translated = requiredurl;

        if ($("#country_code").val() != "") {
            if (filter_mapping.hasOwnProperty($("#country_code").val()) &&
                filter_mapping[$("#country_code").val()].hasOwnProperty(requiredurl.toLowerCase())) {

                translated = filter_mapping[$("#country_code").val()][requiredurl];
            } else {
                translated = requiredurl;
            }
        }

        if ($('.section-groups.section-' + translated).hasClass('hidden')) {
            $('.section-groups.section-' + translated).removeClass('hidden')
        } else {
            $('.section-groups:not(.section-' + translated + ')').addClass('hidden');
            $('input[name=' + translated + ']').addClass('checked');
            $('.collections .selected-values').html(translated);
            $('input[name=' + translated + ']').parent().parent().parent().parent().find('button').addClass('with-values');
        }
    } else {
        $('.section-groups').removeClass('hidden');
    }
}

function hide_collections() {
    var checkedVals = $('#collections input[type=checkbox]').map(function () {
        if ($(this).hasClass('checked')) {
            return $(this).attr('data-name').replace("&", "and");
        }
    }).get();
    // $('.section-groups').removeClass('hidden');
    if (checkedVals.length > 0) {

        for (var i = 0; i < checkedVals.length; i++) {
            var str = checkedVals[i].replace(/\s+/g, '-').toLowerCase().replace("&", "and");


            if ($('.section-groups.section-' + str).hasClass('hidden')) {
                $('.section-groups.section-' + str).removeClass('hidden')
            } else {
                $('.section-groups:not(.section-' + str + ')').addClass('hidden');
            }

        }

    } else {
        $('.section-groups').removeClass('hidden');
    }
}


function get_desktop_collections(id) { // might remove the id here

    $('.section-groups').removeClass('hidden');
    $(".list-counter").removeClass('hidden');
    hide_collections();

    if ($('.section-groups:not(".hidden")').length > 0) {


        // check first if has selection from age -> taste -> occascions
        // check if has content from age


        //looks like this block cycles through the whiskies
        //determines if they have a data value that matches the checkboxes selected
        //and pushes them to an array _age_whisky

        //this gets all whiskies
        var agewhiskycollections = $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing');

        var _age_whisky = [];
        var checkedageVals = $('#age .collection_filter input[type=checkbox]').map(function () {

            if ($(this).hasClass('checked')) {

                var chkData = $(this).attr('data-name').split(',');
                //globalAgeVar = chkData;

                //each checked value
                for (var i = 0; i < chkData.length; i++) {

                    //each whisky
                    for (var x = 0; x < agewhiskycollections.length; x++) {

                        //array of age groups
                        var dataage = agewhiskycollections[x].attributes[2].value.split(',');



                        if ($.inArray(chkData[i], dataage) !== -1) {
                            _age_whisky.push(agewhiskycollections[x]);

                        }

                    }
                }
            }

            return _age_whisky;

        }).get();

        //console.log("age1: " + _age_whisky);

        //if the below is true, then we have matched some ages
        if (_age_whisky.length > 0) {
            //console.log("age2: " + _age_whisky);
            //looks like this hides everything
            $(".section-groups").addClass("hidden")
            $(".section-groups .list-counter:not('.hidden')").addClass("hidden")
            $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing').parent().addClass('hidden');

            //looks like this cycles through the and then removes the hidden class from found whiskies
            for (var j = 0; j < _age_whisky.length; j++) {
                _age_whisky[j].parentElement.classList.remove('hidden');
                var section_group = _age_whisky[j].parentElement.parentElement.parentElement.parentElement.parentElement.attributes[1].value;
                if ($(".section-" + section_group + " .list-counter:not('.hidden')").length === 0) {
                    $(".section-" + section_group).addClass("hidden");
                } else {
                    $(".section-" + section_group).removeClass("hidden");
                }

            }
        }
        else {
            //have any age boxes been checked
            var checkedBoxes = $('#age .collection_filter input[type=checkbox]:checked');

            //if no age boxes were checked we shouldn't hide all
            if (checkedBoxes.length > 0) {
                //nothing matched the age filter, so hide all
                $(".section-groups").addClass("hidden")
                $(".section-groups .list-counter:not('.hidden')").addClass("hidden")
                $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing').parent().addClass('hidden');
                //console.log("matched no ages");
            }
        }



        // taste
        var tasteswhiskycollections = $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing');
        var _tastes_whisky = [];
        var checkedtastesVals = $('#tastes .collection_filter input[type=checkbox]').map(function () {

            if ($(this).hasClass('checked')) {

                $(".section-groups").addClass("hidden")
                $(".section-groups .list-counter:not('.hidden')").addClass("hidden")

                var chkData = $(this).attr('data-name').split(',');
                for (var i = 0; i < chkData.length; i++) {

                    for (var x = 0; x < tasteswhiskycollections.length; x++) {

                        var datatastes = tasteswhiskycollections[x].attributes[3].value.split(',');

                        if ($.inArray(chkData[i], datatastes) !== -1) {

                            _tastes_whisky.push(tasteswhiskycollections[x]);
                            // tasteswhiskycollections[x].parentElement.classList.remove("hidden");

                            // var section_group = _tastes_whisky[j].parentElement.parentElement.parentElement.parentElement.parentElement.attributes[1].value;
                            // if( $(".section-"+section_group+" .list-counter:not('.hidden')").length === 0 ) {
                            //     $(".section-"+section_group).addClass("hidden");
                            // }
                        }

                    }
                }
            }

            return _tastes_whisky;
        }).get();

        if (_tastes_whisky.length > 0) {
            $(".section-groups").addClass("hidden")
            $(".section-groups .list-counter:not('.hidden')").addClass("hidden")
            $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing').parent().addClass('hidden');
            for (var j = 0; j < _tastes_whisky.length; j++) {
                _tastes_whisky[j].parentElement.classList.remove('hidden');
                var section_group = _tastes_whisky[j].parentElement.parentElement.parentElement.parentElement.parentElement.attributes[1].value;
                if ($(".section-" + section_group + " .list-counter:not('.hidden')").length === 0) {
                    $(".section-" + section_group).addClass("hidden");
                } else {
                    $(".section-" + section_group).removeClass("hidden");
                }

            }
        }

        //occasions
        var occasionswhiskycollections = $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing');
        var _occasions_whisky = [];
        var checkedoccasionsVals = $('#occasions .collection_filter input[type=checkbox]').map(function () {

            if ($(this).hasClass('checked')) {
                $(".section-groups").addClass("hidden")
                $(".section-groups .list-counter:not('.hidden')").addClass("hidden")

                var chkData = $(this).attr('data-name').split(',');
                for (var i = 0; i < chkData.length; i++) {

                    for (var x = 0; x < occasionswhiskycollections.length; x++) {

                        var dataoccasions = occasionswhiskycollections[x].attributes[1].value.split(',');

                        if ($.inArray(chkData[i], dataoccasions) !== -1) {
                            _occasions_whisky.push(occasionswhiskycollections[x]);
                        }

                    }
                }
            }

            return _occasions_whisky;
        }).get();

        if (_occasions_whisky.length > 0) {
            $(".section-groups").addClass("hidden")
            $(".section-groups .list-counter:not('.hidden')").addClass("hidden")
            $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing').parent().addClass('hidden');
            for (var j = 0; j < _occasions_whisky.length; j++) {
                _occasions_whisky[j].parentElement.classList.remove('hidden');
                var section_group = _occasions_whisky[j].parentElement.parentElement.parentElement.parentElement.parentElement.attributes[1].value;
                if ($(".section-" + section_group + " .list-counter:not('.hidden')").length === 0) {
                    $(".section-" + section_group).addClass("hidden");
                } else {
                    $(".section-" + section_group).removeClass("hidden");
                }

            }
        }

        if ($('.section-groups:not(".hidden")').length === 0) {
             if ($("#country_code").val() == "zh-tw") {
                $(".whisky-header-text").html("抱歉，沒有符合您搜尋條件的產品。請更新過濾結果並重試").addClass('_header-text-whisky'); 
             } else {
                $(".whisky-header-text").html("Sorry, there are no products matching your search criteria. Please update the filter results and try again").addClass('_header-text-whisky');     
             }
            
        } else {
            $(".whisky-header-text").html(header_text).removeClass('_header-text-whisky');
        }

    }

}

function get_mobile_collections() {
    $('.section-groups').removeClass('hidden');
    $(".list-counter").removeClass('hidden');

    // collections
    var checkedVals = $('#mobile-collections input[type=checkbox]').map(function () {
        if ($(this).hasClass('checked')) {
            // try to add class from all sections
            return $(this).attr('data-name');
        }
    }).get();

    if (checkedVals.length > 0) {

        for (var i = 0; i < checkedVals.length; i++) {
            var str = checkedVals[i].replace(/\s+/g, '-').toLowerCase().replace("&", "and");


            if ($('.section-groups.section-' + str).hasClass('hidden')) {
                $('.section-groups.section-' + str).removeClass('hidden')
            } else {
                $('.section-groups:not(.section-' + str + ')').addClass('hidden');
            }

        }

    } else {
        $('.section-groups').removeClass('hidden');
    }


    if ($('.section-groups:not(".hidden")').length > 0) {


        // check first if has selection from age -> taste -> occascions
        // check if has content from age

        var agewhiskycollections = $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing');
        var _age_whisky = [];
        var checkedageVals = $('#mobile-age input[type=checkbox]').map(function () {

            if ($(this).hasClass('checked')) {

                var chkData = $(this).attr('data-name').split(',');
                for (var i = 0; i < chkData.length; i++) {

                    for (var x = 0; x < agewhiskycollections.length; x++) {

                        var dataage = agewhiskycollections[x].attributes[2].value.split(',');

                        if ($.inArray(chkData[i], dataage) !== -1) {
                            _age_whisky.push(agewhiskycollections[x]);
                        }

                    }
                }
            }

            return _age_whisky;
        }).get();

        if (_age_whisky.length > 0) {
            $(".section-groups").addClass("hidden")
            $(".section-groups .list-counter:not('.hidden')").addClass("hidden")
            $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing').parent().addClass('hidden');
            for (var j = 0; j < _age_whisky.length; j++) {
                _age_whisky[j].parentElement.classList.remove('hidden');
                var section_group = _age_whisky[j].parentElement.parentElement.parentElement.parentElement.parentElement.attributes[1].value;
                if ($(".section-" + section_group + " .list-counter:not('.hidden')").length === 0) {
                    $(".section-" + section_group).addClass("hidden");
                } else {
                    $(".section-" + section_group).removeClass("hidden");
                }

            }
        }



        // taste
        var tasteswhiskycollections = $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing');
        var _tastes_whisky = [];
        var checkedtastesVals = $('#mobile-tastes input[type=checkbox]').map(function () {

            if ($(this).hasClass('checked')) {

                $(".section-groups").addClass("hidden")
                $(".section-groups .list-counter:not('.hidden')").addClass("hidden")

                var chkData = $(this).attr('data-name').split(',');
                for (var i = 0; i < chkData.length; i++) {

                    for (var x = 0; x < tasteswhiskycollections.length; x++) {

                        var datatastes = tasteswhiskycollections[x].attributes[3].value.split(',');

                        if ($.inArray(chkData[i], datatastes) !== -1) {

                            _tastes_whisky.push(tasteswhiskycollections[x]);
                            // tasteswhiskycollections[x].parentElement.classList.remove("hidden");

                            // var section_group = _tastes_whisky[j].parentElement.parentElement.parentElement.parentElement.parentElement.attributes[1].value;
                            // if( $(".section-"+section_group+" .list-counter:not('.hidden')").length === 0 ) {
                            //     $(".section-"+section_group).addClass("hidden");
                            // }
                        }

                    }
                }
            }

            return _tastes_whisky;
        }).get();

        if (_tastes_whisky.length > 0) {
            $(".section-groups").addClass("hidden")
            $(".section-groups .list-counter:not('.hidden')").addClass("hidden")
            $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing').parent().addClass('hidden');
            for (var j = 0; j < _tastes_whisky.length; j++) {
                _tastes_whisky[j].parentElement.classList.remove('hidden');
                var section_group = _tastes_whisky[j].parentElement.parentElement.parentElement.parentElement.parentElement.attributes[1].value;
                if ($(".section-" + section_group + " .list-counter:not('.hidden')").length === 0) {
                    $(".section-" + section_group).addClass("hidden");
                } else {
                    $(".section-" + section_group).removeClass("hidden");
                }

            }
        }

        //occasions
        var occasionswhiskycollections = $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing');
        var _occasions_whisky = [];
        var checkedoccasionsVals = $('#mobile-occasions input[type=checkbox]').map(function () {

            if ($(this).hasClass('checked')) {
                $(".section-groups").addClass("hidden")
                $(".section-groups .list-counter:not('.hidden')").addClass("hidden")

                var chkData = $(this).attr('data-name').split(',');
                for (var i = 0; i < chkData.length; i++) {

                    for (var x = 0; x < occasionswhiskycollections.length; x++) {

                        var dataoccasions = occasionswhiskycollections[x].attributes[1].value.split(',');

                        if ($.inArray(chkData[i], dataoccasions) !== -1) {
                            _occasions_whisky.push(occasionswhiskycollections[x]);
                        }

                    }
                }
            }

            return _occasions_whisky;
        }).get();

        if (_occasions_whisky.length > 0) {
            $(".section-groups").addClass("hidden")
            $(".section-groups .list-counter:not('.hidden')").addClass("hidden")
            $('.section-groups:not(".hidden") .list-counter:not(".hidden") ._collection-whisky-listing').parent().addClass('hidden');
            for (var j = 0; j < _occasions_whisky.length; j++) {
                _occasions_whisky[j].parentElement.classList.remove('hidden');
                var section_group = _occasions_whisky[j].parentElement.parentElement.parentElement.parentElement.parentElement.attributes[1].value;
                if ($(".section-" + section_group + " .list-counter:not('.hidden')").length === 0) {
                    $(".section-" + section_group).addClass("hidden");
                } else {
                    $(".section-" + section_group).removeClass("hidden");
                }

            }
        }

        if ($('.section-groups:not(".hidden")').length === 0) {
            if ($("#country_code").val() == "zh-tw") {
                $(".whisky-header-text").html("抱歉，沒有符合您搜尋條件的產品。請更新過濾結果並重試").addClass('_header-text-whisky'); 
            } else {
                $(".whisky-header-text").html("Sorry, there are no products matching your search criteria. Please update the filter results and try again").addClass('_header-text-whisky');     
            }
        } else {
            $(".whisky-header-text").html(header_text).removeClass('_header-text-whisky');
        }

    }


    return false;

    var checkedVals = $('#mobile-collections input[type=checkbox]').map(function () {
        if ($(this).hasClass('checked')) {
            // try to add class from all sections
            return $(this).attr('data-name');
        }
    }).get();

    if (checkedVals.length > 0) {

        for (var i = 0; i < checkedVals.length; i++) {
            var str = checkedVals[i].replace(/\s+/g, '-').toLowerCase().replace("&", "and");


            if ($('.section-groups.section-' + str).hasClass('hidden')) {
                $('.section-groups.section-' + str).removeClass('hidden')
            } else {
                $('.section-groups:not(.section-' + str + ')').addClass('hidden');
            }

        }

    } else {
        $('.section-groups').removeClass('hidden');
    }


    var allwhiskycollections = $('.section-groups:not(".hidden") ._collection-whisky-listing');
    $('.section-groups:not(".hidden") ._collection-whisky-listing').parent().addClass('hidden');

    var checkedVals = $('.mobile_filter input[type=checkbox]').map(function () {
        if ($(this).hasClass('checked')) {

            for (var x = 0; x < allwhiskycollections.length; x++) {

                var dataage = allwhiskycollections[x].attributes[2].value.split(',');
                var dataoccasions = allwhiskycollections[x].attributes[1].value.split(',');
                var datatastes = allwhiskycollections[x].attributes[3].value.split(',');

                var chkData = $(this).attr('data-name').split(',');

                for (var i = 0; i < chkData.length; i++) {
                    if ($.inArray(chkData[i], dataage) !== -1) {
                        var dataagejoin = dataage.join();
                        var elements = document.querySelectorAll('[data-age="' + dataagejoin + '"]');
                        for (var j = 0; j < elements.length; j++) {
                            elements[j].parentElement.classList.remove('hidden')
                        }

                    } else if ($.inArray(chkData[i], dataoccasions) !== -1) {
                        var dataoccasionsjoin = dataoccasions.join();
                        var elements = document.querySelectorAll('[data-occasions="' + dataoccasionsjoin + '"]');
                        for (var j = 0; j < elements.length; j++) {
                            elements[j].parentElement.classList.remove('hidden')
                        }
                    } else if ($.inArray(chkData[i], datatastes) !== -1) {
                        var datatastesjoin = datatastes.join();
                        var elements = document.querySelectorAll('[data-tastes="' + datatastesjoin + '"]');
                        for (var j = 0; j < elements.length; j++) {
                            elements[j].parentElement.classList.remove('hidden')
                        }
                    }
                }

            }

            return $(this).attr('data-name');
        }
    }).get();

    if (checkedVals.length < 1) {
        $('._collection-whisky-listing').parent().removeClass('hidden');
    }

}


function show_selected_mobile_values() {

    var checkedVals = $('.filter-modal-wrapper input[type=checkbox]').map(function () {
        if ($(this).hasClass('checked')) {
            return $(this).val();
        }
    }).get();

    selected_mobile_values = checkedVals.join('+');

    if (checkedVals.length > 0) {
        $('.btn-filter').addClass('with-values');
        $('.filter--count').html(checkedVals.length);
        $('.filter--footer-counter').html(checkedVals.length);

    } else {
        $('.filter--count').html("");
        $('.btn-filter').removeClass('with-values');
        $('.filter--footer-counter').html('&nbsp;');

    }
}

function show_selected_values(data_from) {

    var result = [];
    var checkedVals = [];
    checkedVals = $('#' + data_from + ' input[type=checkbox]').map(function () {
        if ($(this).hasClass('checked')) {
            return $(this).attr('data-name');
        }
    }).get();


    if (checkedVals.length > 0) {
        var selected_values = "";
        selected_values = checkedVals.join(', ');
        $('.' + data_from + ' button.accordion').addClass('with-values');

        var resultLabel = selected_values.slice(0, 30) + (selected_values.length > 10 ? "..." : "");
        $('.' + data_from + ' .selected-values').html(resultLabel);

    } else {
        $('.' + data_from + ' .selected-values').html("");
        $('.' + data_from + ' button.accordion').removeClass('with-values');
    }
}

function accordion() {
    const accordionBtns = document.querySelectorAll(".accordion");

    accordionBtns.forEach((accordion) => {
        accordion.onclick = function () {
            this.classList.toggle("is-open");

            let content = this.nextElementSibling;
            // console.log(content);

            if (content.style.maxHeight) {
                //this is if the accordion is open
                content.style.maxHeight = null;
            } else {
                //if the accordion is currently closed
                content.style.maxHeight = content.scrollHeight + "px";
            }
        };
    });
}


// archive codes
function get_all_collections(collection, id) {

    var allwhiskycollections = $('._collection-whisky-listing');
    allwhiskycollections.parent().addClass('hidden');
    var checkedVals = $('#' + collection + ' input[type=checkbox]').map(function () {
        if ($(this).hasClass('checked')) {

            for (var i = 0; i < allwhiskycollections.length; i++) {

                var whiskycollection = allwhiskycollections[i].attributes[id].value.split(',');
                var vals = $(this).attr('data-name').split(',');

                for (var j = 0; j < vals.length; j++) {

                    if ($.inArray(vals[j], whiskycollection) !== -1) {
                        allwhiskycollections[i].parentElement.classList.remove('hidden');
                    }

                }

            }

            return $(this).attr('data-name');
        }
    }).get();

    if (checkedVals.length < 1) {
        allwhiskycollections.parent().removeClass('hidden');
    }
}


function gate_modal() {
    check_age_gate();

    $("body #LDAForm_LDAForm_action_LDAFormProcess").on("click", function () {
        age_gate_validate();
    });

    $('body #go-back').click(function () {
        // return ecverythign
        $(".gate-modal-title").html("welcome");
        $("body #LDAForm_LDAForm_action_LDAFormProcess").removeClass("hidden");
        $("body #go-back").addClass("hidden");

        $(".gate-modal-desc").removeClass("hidden");
        $(".form-wrapper").removeClass("hidden");

        $('.gate-modal-title').removeAttr('style');

    });
}

function age_gate_validate() {

    var _error = [];
    var result = true;

    var allowed_age = false;

    if ($("#gate-modal .dv-group-full").hasClass("hidden")) {

        $('#gate-modal #full-year').val($('#gate-modal #year').val());
    }


    // day      = $("body .day .select-selected").html() == "DD" ? "" : $("body .day .select-selected").html();
    // month    = $("body .month .select-selected").html() == "MM" ? "" : $("body .month .select-selected").html();
    // year     = $("body .year .select-selected").html() == "YYYY" ? "" : $("body .year .select-selected").html();
    location = $("body .location .select-items.select-hide .selected").attr('data-value') == undefined ? "" : $("body .location .select-items.select-hide .selected").attr('data-value');

    // if( location == "" || location == undefined ) {
    //     _error.push("Location");
    //     $("body #location").addClass("has-error");
    // } else {
    //     $("body #location").removeClass("has-error");
    // }

    if ($("#gate-modal .dv-group-full").hasClass("hidden")) {

        var year = $('#gate-modal #year').val();

        if (year == "" || year == undefined) {

            _error.push("Year");
            $("#gate-modal #year").addClass("has-error");
        } else {

            $("#gate-modal #year").removeClass("has-error");
        }


        if (_error.length > 0) {

            result = false;
        } else {

            var today = new Date();
            var age_year = today.getFullYear() - year;

            if (isNaN(age_year)) {

                $("#gate-modal #year").addClass("has-error");
                return;
            } else {

                $("#gate-modal #year").removeClass("has-error");
            }

            //console.log("XLocation:" + location +", Age Year" + age_year );

            if (location == "US" || location == "DE" || location == "IN") {

                //console.log("Location:" + location +", Age Year" + age_year );
                if ((age_year == 21)) {
                    $("#gate-modal .dv-group-full").removeClass("hidden");
                    $("#gate-modal #dv-group").addClass("hidden");
                    $("#year_date_switch").html("ENTER DATE OF BIRTH");
                    return;
                } else if (age_year < 21) {
                    $("#gate-modal .dv-group-full").addClass("hidden");
                    $("#gate-modal #dv-group").removeClass("hidden");
                    age_young_tovisit();
                } else if (age_year > 21) {
                    allowed_age = true;
                }

            } else if (location == "KR") {

                if ((age_year == 19)) {
                    $("#gate-modal .dv-group-full").removeClass("hidden");
                    $("#gate-modal #dv-group").addClass("hidden");
                    $("#year_date_switch").html("ENTER DATE OF BIRTH");
                    return;
                } else if (age_year < 19) {
                    $("#gate-modal .dv-group-full").addClass("hidden");
                    $("#gate-modal #dv-group").removeClass("hidden");
                    age_young_tovisit();
                } else if (age_year > 19) {
                    allowed_age = true;
                }

            } else {

                //default to 18 years old for non specific countries
                if ((age_year == 18)) {

                    $("#gate-modal .dv-group-full").removeClass("hidden");
                    $("#gate-modal #dv-group").addClass("hidden");
                    $("#year_date_switch").html("ENTER DATE OF BIRTH");
                    return;
                } else if (age_year < 18) {

                    $("#gate-modal .dv-group-full").addClass("hidden");
                    $("#gate-modal #dv-group").removeClass("hidden");
                    age_young_tovisit();
                } else if (age_year > 18) {

                    allowed_age = true;
                }


            }
        }


    } else {

        var full_day = $('#gate-modal #full-day').val();
        var full_month = $('#gate-modal #full-month').val();
        var full_year = $('#gate-modal #full-year').val();

        if ((full_day == "" || full_day == undefined) || isNaN(full_day)) {

            _error.push("Day");
            $("#gate-modal #full_day").addClass("has-error");
        } else {

            $("#gate-modal #full_day").removeClass("has-error");
        }

        if ((full_month == "" || full_month == undefined) || isNaN(full_month)) {

            _error.push("Month");
            $("#gate-modal #full_month").addClass("has-error");
        } else {

            $("#gate-modal #full_month").removeClass("has-error");
        }

        if ((full_year == "" || full_year == undefined) || isNaN(full_month)) {

            _error.push("Year");
            $("body #full_year").addClass("has-error");
        } else {

            $("body #full_year").removeClass("has-error");
        }

        if (_error.length > 0) {

            result = false;
        } else {

            var today = new Date();
            var birthDate = new Date(full_year, (full_month - 1), full_day);

            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            if ((new Date(Date.now()) === birthDate) || (new Date(Date.now()) > birthDate)) {
                //console.log("same date");

                if (location == "US" || location == "DE" || location == "IN") {
                    if (age >= 21) {
                        allowed_age = true;
                    } else if (age < 21) {
                        age_young_tovisit();
                    }
                }

                else if (location == "KR") {
                    if (age >= 19) {
                        allowed_age = true;
                    } else if (age < 19) {
                        age_young_tovisit();
                    }
                }

                else {

                    if (age >= 18) {
                        allowed_age = true;
                    } else if (age < 18) {
                        age_young_tovisit();
                    }

                }

            }
        }


    }

    if (allowed_age) {

        setCookieOverride(location);

        $(".age-gate-modal-dialog").css({
            'opacity': 0,
            'pointer-events': 'auto'
        }).addClass("hidden").css("z-index", "-99999");
        triggerSignup();
        //ensure top of page
        $(document).scrollTop(0);

        $('body').removeClass("overflow-hidden");
        var lowercaseLocation = location.toLowerCase();

        let matchingRedirectPath = checkPagePathToRedirect('sign-up');
        
        if (location != "GB") {
            $('#maxemail_age_gate_country').val(location);

            if (lowercaseLocation == "xx") {

                if ($("#country_code").val() != "") {

                    if (matchingRedirectPath) {
                        console.log('matching path', $("#country_code").val());
                        window.location.href = "https://" + domain + '/' + matchingRedirectPath;
                    } else {
                        window.location.href = "https://" + domain;
                    }
                }
            } else if (lowercaseLocation == "us") {
                if ($("#country_code").val() != "en-us") {

                    if (matchingRedirectPath) {
                        window.location.href = "https://" + domain + "/en-us/" + matchingRedirectPath;
                    } else {
                        window.location.href = "https://" + domain + "/en-us/";
                    }

                }
            } else if (lowercaseLocation == "in") {
                if ($("#country_code").val() != "en-in") {
                    window.location.href = "https://" + domain + "/in/";
                }
            } else if (lowercaseLocation == "au") {
                if ($("#country_code").val() != "en-au") {
                    window.location.href = "https://" + domain + "/en-au/";
                }
            } else if (lowercaseLocation == "fr") {
                if ($("#country_code").val() != "fr-fr") {
                    window.location.href = "https://" + domain + "/fr-fr/";
                }
            } else if (lowercaseLocation == "cn") {
                if ($("#country_code").val() != "zh-cn") {
                    window.location.href = "https://" + domain + "/cn/";
                }
            } else if (lowercaseLocation == "tw") {
                if ($("#country_code").val() != "zh-tw") {
                    window.location.href = "https://" + domain + "/zh-tw/";
                }
            } else if (lowercaseLocation == "de") {

                if ($("#country_code").val() != "de-de") {
                    window.location.href = "https://" + domain + "/de-de/";
                }
            } else if (lowercaseLocation == "sg") {

                if ($("#country_code").val() != "en-sg") {
                    window.location.href = "https://" + domain + "/en-sg/";
                }
            } else if (lowercaseLocation == "id") {

                if ($("#country_code").val() != "en-id") {
                    window.location.href = "https://" + domain + "/en-id/";
                }
            } else if (lowercaseLocation == "ph") {

                if ($("#country_code").val() != "en-ph") {
                    window.location.href = "https://" + domain + "/en-ph/";
                }
            } else if (lowercaseLocation == "my") {

                if ($("#country_code").val() != "en-my") {
                    window.location.href = "https://" + domain + "/en-my/";
                }
            } else {

                if (lowercaseLocation != $("#country_code").val()) {
                    window.location.href = "https://" + domain + "/" + lowercaseLocation + "/";
                }
            }
        } else {

            $('#maxemail_age_gate_country').val(location)
            if ($("#country_code").val() != "en-gb") {
                if (matchingRedirectPath) {
                    window.location.href = "https://" + domain + "/en-gb/" + matchingRedirectPath;
                } else {
                    window.location.href = "https://" + domain + "/en-gb/";
                }
            }
        }

        $("body").css("overflow", "auto");
    }

    return result;

}

function check_age_gate() {

    var age_gate = getCookie("age_gate");

    if (age_gate == null) {
        $(".age-gate-modal-dialog").css({
            'opacity': 1,
            'pointer-events': 'auto'
        }).removeClass("hidden");
        $('body').addClass("overflow-hidden");
    } else {
        $('body').removeClass("overflow-hidden");
        triggerSignup();
    }

    var age_gate_country = getCookie("age_gate_country");
    if (age_gate_country != null) {
        $('#maxemail_age_gate_country').val(age_gate_country)
    }

}

function age_young_tovisit() {
    $(".gate-modal-title").html("You are too young to visit this website.");
    $("body #LDAForm_LDAForm_action_LDAFormProcess").addClass("hidden");
    $("body #go-back").removeClass("hidden");

    $(".gate-modal-desc").addClass("hidden");
    $(".form-wrapper").addClass("hidden");
}

function getCookie(name) {
    name = name + '=';

    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();

        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
}

function age_gate_custom_select() {
    var x, i, j, l, ll, selElmnt, a, b, c;
    /*look for any elements with the class "custom-select":*/
    x = document.querySelectorAll(".select-stag-wrapper .custom-select");
    l = x.length;
    for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        /*for each element, create a new DIV that will act as the selected item:*/
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /*for each element, create a new DIV that will contain the option list:*/
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 1; j < ll; j++) {
            /*for each option in the original select element,
            create a new DIV that will act as an option item:*/
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.setAttribute("data-value", selElmnt.options[j].value);
            c.addEventListener("click", function (e) {
                /*when an item is clicked, update the original select box,
                and the selected item:*/
                var y, i, k, s, h, sl, yl;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                sl = s.length;
                h = this.parentNode.previousSibling;
                for (i = 0; i < sl; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {

                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName("selected");
                        yl = y.length;
                        for (k = 0; k < yl; k++) {
                            y[k].removeAttribute("class");
                        }

                        this.setAttribute("class", "selected");
                        break;
                    }
                }
                h.click();
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function (e) {
            /*when the select box is clicked, close any other select boxes,
            and open/close the current select box:*/
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
        });
    }
    function closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
        except the current select box:*/
        var x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }
    /*if the user clicks anywhere outside the select box,
    then close all select boxes:*/
    document.addEventListener("click", closeAllSelect);
}

function animate_age_gate_stag() {
    var elStag = $('#ag-stag-bg-image');

    var right = function () {
        elStag.animate({ x: -180 }, 20000, left);
    };

    var left = function () {
        elStag.animate({ x: -100 }, 20000, right);
    };

    right();

}

/* Check the page path for a match and redirect */
function checkPagePathToRedirect(path) {
    let currentPath = window.location.pathname;
    let url = '';
    let searchParams = window.location.search;
    let exactMatchPath = '/' + path;

    if (currentPath === exactMatchPath) {
        return path + searchParams;
    } else if (currentPath.includes(exactMatchPath)) {
        return path + searchParams;
    } else {
        return false;
    }

    return false;

}
